import { Flex, FormControl } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { SelectButton } from "../../components/Forms/SelectButton";
import { useSeller } from "../../hooks/useSeller";
import { AntifraudServiceSeller } from "../../models/Sellers";
import { showToast } from "../../utils";
import { Section } from "./_Section";

const editAntiFraudSchema = yup.object().shape({
  ghostModeEnable: yup.boolean(),
});

interface AntiFraudSectionProps {
  defaultGhostModeEnable: boolean;
  activeAntiFraud: boolean;
  antifraudService: AntifraudServiceSeller;
}

interface AntiFraudSectionData {
  ghostModeEnable: boolean;
  activeAntiFraudEnable: boolean;
  antifraudService: AntifraudServiceSeller;
}

export function AntiFraudSection({
  defaultGhostModeEnable,
  activeAntiFraud,
  antifraudService,
}: AntiFraudSectionProps) {
  const { patchGhostMode, patchAntifraud, patchAntifraudService } = useSeller();
  let { id } = useParams();
  const [editSection, setEditSection] = useState("");
  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const approvedEmails = [
    "luirla.falcao@barte.com",
    "luirla.falca.backoffice@barte.com",
    "cesar.gomes.backoffice@barte.com",
    "cesar.gomes@backoffice.com",
    "cesar.gomes@barte.com",
    "ely.vasconcelos.backoffice@barte.com",
    "vinicius.telles2@barte.com",
    "elson.backoffice@barte.com",
    "milare@barte.com",
    "marcela.giannella@barte.com",
    "giovani@barte.com",
    "giovanni@barte.com",
    "gustavo.backoffice@barte.com",
    "marcela.giannella.backoffice@barte.com",
    "wesley.silva.backoffice@barte.com",
  ];
  const { register, handleSubmit, setValue, watch } = useForm({
    resolver: yupResolver(editAntiFraudSchema),
  });
  const antiFraudValue = watch("activeAntiFraudEnable");
  useEffect(() => {
    setValue("ghostModeEnable", defaultGhostModeEnable ? "1" : "0");
    setValue("activeAntiFraudEnable", activeAntiFraud ? "1" : "0");
    setValue("antifraudService", antifraudService);
    //eslint-disable-next-line
  }, [defaultGhostModeEnable, activeAntiFraud, antifraudService]);

  useEffect(() => {
    if (antiFraudValue === "0") {
      setValue("ghostModeEnable", "0");
    }
    //eslint-disable-next-line
  }, [antiFraudValue]);
  const onSubmit = handleSubmit(
    async ({
      ghostModeEnable,
      activeAntiFraudEnable,
      antifraudService,
    }: AntiFraudSectionData) => {
      try {
        const antiFraudData = {
          ghostModeEnable: ghostModeEnable ?? false,
          activeAntiFraud: activeAntiFraudEnable ?? false,
        };

        await Promise.all([
          patchGhostMode(id, antiFraudData.ghostModeEnable),
          patchAntifraud(id, antiFraudData.activeAntiFraud),
          patchAntifraudService(Number(id), antifraudService),
        ]);
        setEditSection("");
        showToast({
          message: "Informacoes editadas com sucesso",
          type: "success",
        });
      } catch (error: any) {
        setEditSection("");
        setValue("ghostModeEnable", defaultGhostModeEnable ? "1" : "0");
        setValue("activeAntiFraud", activeAntiFraud ? "1" : "0");
        error?.response?.data?.errors?.map((error: any) =>
          showToast({
            type: "error",
            message: `${error?.code} - ${error?.description}`,
          })
        );
        return;
      }
    }
  );
  return (
    <Section
      sectionTitle="Geral"
      isEdit={editSection === "general"}
      onClickEditButton={() => setEditSection("general")}
      onClickConfirmButton={onSubmit}
      statusSection={activeAntiFraud ? "ACTIVE" : "INACTIVE"}
      isEditButtonHidden={!approvedEmails?.includes(user?.email)}
    >
      <Flex gap={2} direction="column">
        <Flex>
          <FormControl maxWidth="280px">
            <SelectButton
              name="activeAntiFraudEnable"
              disabled={editSection !== "general"}
              label="Anti-fraude status"
              variant="ghost"
              bgColor="#EDF1F7"
              h="27px"
              register={{ ...register("activeAntiFraudEnable") }}
            >
              <option value="0">Inativo</option>
              <option value="1">Ativo</option>
            </SelectButton>
          </FormControl>

          <FormControl maxWidth="280px">
            <SelectButton
              name="ghostMode"
              disabled={editSection !== "general" || antiFraudValue === "0"}
              label="Ghost mode"
              variant="ghost"
              bgColor="#EDF1F7"
              h="27px"
              register={{ ...register("ghostModeEnable") }}
            >
              <option value="0">Desabilitado</option>
              <option value="1">Habilitado</option>
            </SelectButton>
          </FormControl>

          <FormControl maxWidth="280px">
            <SelectButton
              name="antifraudService"
              disabled={editSection !== "general" || antiFraudValue === "0"}
              label="Serviço de Antifraude"
              variant="ghost"
              bgColor="#EDF1F7"
              h="27px"
              register={{ ...register("antifraudService") }}
            >
              <option value="NETHONE">Nethone</option>
              <option value="OSCILAR">Oscilar</option>
              {/* <option value="BARTE">Barte</option> */}
            </SelectButton>
          </FormControl>
        </Flex>
      </Flex>
    </Section>
  );
}
